/** @jsx jsx */
import { jsx, Text } from "theme-ui";

import { ActionButton } from "office-ui-fabric-react";
import DefaultLayout from "../../layouts/dlw-mobile";

import MenuItems from "../../components/MenuItems";
import daajiMenuItems from "../../components/MenuItems/daajiItems";

const getMandatoryEnv = require("sites-common/utils/getMandatoryEnv");

const { profileBaseUrl } = getMandatoryEnv(["keycloakConfig"]);

const Index = (/* { data } */) => {
  return (
    <DefaultLayout>
      <div sx={{ mt: 4 }}>
        <ActionButton
          text="Back"
          iconProps={{ iconName: "Back" }}
          href={`${profileBaseUrl}/my-applications`}
        />
        <div sx={{ pt: 2, textAlign: "center" }}>
          <Text variant="header">Daaji&apos;s Section</Text>
        </div>
        <MenuItems items={daajiMenuItems} />
      </div>
    </DefaultLayout>
  );
};

export default Index;
